const copyFallback = (text) => {
  if (typeof document === 'undefined') {
    return false
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.top = '0'
  textarea.style.left = '0'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)

  try {
    textarea.focus()
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)
    return document.execCommand('copy')
  } finally {
    document.body.removeChild(textarea)
  }
}

const CopyText = async (value) => {
  const text = String(value ?? '')
  if (!text) return false

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (error) {
      // В небезопасном контексте Clipboard API может быть недоступен.
    }
  }

  if (copyFallback(text)) return true

  throw new Error('Не удалось скопировать текст')
}

export default CopyText
